export default "__VITE_ASSET__BcHI$uQi__"